import { render, staticRenderFns } from "./editAnswer.vue?vue&type=template&id=4c5dd5ff&scoped=true"
import script from "./editAnswer.vue?vue&type=script&lang=js"
export * from "./editAnswer.vue?vue&type=script&lang=js"
import style0 from "./editAnswer.vue?vue&type=style&index=0&id=4c5dd5ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5dd5ff",
  null
  
)

export default component.exports